import { useRef, useState } from "react";

const SpotlightCard = ({
  icon: Icon,
  title,
  description,
  className = "",
  spotlightColor = "rgba(255, 255, 255, 0.25)",
}) => {
  const divRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [opacity, setOpacity] = useState(0);

  const handleMouseMove = (e) => {
    if (!divRef.current || isFocused) return;
    const rect = divRef.current.getBoundingClientRect();
    setPosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return (
    <div
      ref={divRef}
      onMouseMove={handleMouseMove}
      onFocus={() => {
        setIsFocused(true);
        setOpacity(0.6);
      }}
      onBlur={() => {
        setIsFocused(false);
        setOpacity(0);
      }}
      onMouseEnter={() => setOpacity(0.6)}
      onMouseLeave={() => setOpacity(0)}
      className={`relative flex items-center gap-4 rounded-2xl overflow-hidden px-6 py-6
        bg-gradient-to-br from-[#1a1a1a] to-[#2a2a2a]   /* lighter than background */
        shadow-[0_10px_20px_rgba(0,0,0,0.8),0_-3px_8px_rgba(255,255,255,0.08),inset_0_1px_2px_rgba(255,255,255,0.15)]
        ring-1 ring-white/10
        scale-[1.02]
        transition-transform
        ${className}`}
    >
      {/* spotlight effect */}
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 ease-in-out rounded-2xl"
        style={{
          opacity,
          background: `radial-gradient(circle at ${position.x}px ${position.y}px, ${spotlightColor}, transparent 80%)`,
        }}
      />

      {/* Icon with depth */}
      <div
        className="relative flex h-14 w-14 items-center justify-center rounded-xl text-white shrink-0
  bg-gradient-to-br from-[#235DE6] to-[#235DE6]
  shadow-[0_4px_10px_rgba(0,0,0,0.6),inset_0_2px_4px_rgba(255,255,255,0.2)]
  ring-1 ring-white/20"
      >
        {Icon && <Icon className="h-7 w-7 drop-shadow-lg" />}
      </div>

      {/* Text */}
      <div className="relative z-10">
        <h3 className="text-lg font-semibold text-white">{title}</h3>
        <p className="text-sm text-neutral-300 mt-1">{description}</p>
      </div>
    </div>
  );
};

export default SpotlightCard;
